var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_line/Pay"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 14 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 10.9031C2.5 8.1078 4.73858 5.84174 7.5 5.84174H22.5C25.2614 5.84174 27.5 8.1078 27.5 10.9031V21.0259C27.5 23.8212 25.2614 26.0873 22.5 26.0873H7.5C4.73858 26.0873 2.5 23.8212 2.5 21.0259V10.9031ZM7.5 8.37243C6.11929 8.37243 5 9.50546 5 10.9031V21.0259C5 22.4236 6.11929 23.5566 7.5 23.5566H22.5C23.8807 23.5566 25 22.4236 25 21.0259V10.9031C25 9.50546 23.8807 8.37243 22.5 8.37243H7.5Z",
    fill: "url(#paint0_linear_1_381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 24 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.25 14.6992H3.75V12.1685H26.25V14.6992Z",
    fill: "url(#paint1_linear_1_381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 25 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.25 19.7606C16.25 19.0617 16.8096 18.4952 17.5 18.4952L21.25 18.4952C21.9404 18.4952 22.5 19.0617 22.5 19.7606C22.5 20.4594 21.9404 21.0259 21.25 21.0259L17.5 21.0259C16.8096 21.0259 16.25 20.4594 16.25 19.7606Z",
    fill: "url(#paint2_linear_1_381)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_381",
    x1: 2.92049,
    y1: 5.84173,
    x2: 28.0295,
    y2: 6.52124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_381",
    x1: 4.12844,
    y1: 12.1685,
    x2: 25.9159,
    y2: 16.4137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_381",
    x1: 16.3551,
    y1: 18.4952,
    x2: 22.6186,
    y2: 18.8342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A0AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#076B9E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPayment);
export default __webpack_public_path__ + "static/media/icon_payment.11514c12fa92d1b6998bdc0791a8cd14.svg";
export { ForwardRef as ReactComponent };